/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { BigPlayButton } from "../../Interface";

import "./Container.scss";

export const InitPlaybackOverlay = () => {
  return (
    <div className="OverlayContainer">
      <div className="OverlayContainer__CenterSection">
        <BigPlayButton />
      </div>
    </div>
  );
};
